import React, { Component } from "react";
import Chart from "react-apexcharts";
import moment from "moment";

export default class BarGraphVoorspel extends Component {
  render() {
    const { sensor, type, soort } = this.props;

    const soortsensor = (soortmeter) => {
      if (soortmeter === "electra") {
        return { naam: "kWh", waarde: 1, titel: "Electriciteit" };
      } else if (soortmeter === "water") {
        return { naam: "m³", waarde: 1000, titel: "Water" };
      } else if (soortmeter === "gas") {
        return { naam: "m³", waarde: 100, titel: "Gas" };
      } else if (soortmeter === "temperatuur") {
        return { naam: "C", waarde: 100, titel: "Temperatuur" };
      } else {
        return { naam: "kWh", waarde: 1, titel: "Electriciteit" };
      }
    };

    // Prepare data for ApexCharts
    function prepareApexData(sensordata) {
      if (!sensordata || !sensordata.forecast || !Array.isArray(sensordata.forecast)) return { barSeries: [], maxSeries: [], minSeries: [], categories: [] };
      
      const barSeries = [];
      const maxSeries = [];
      const minSeries = [];
      const categories = [];

      sensordata.forecast.forEach(function (a, key) {
        if (a.datum && a.value) {
          let value = parseFloat(a.value.toFixed(2));
          if (type === "uur" && key > 0) {
            value -= sensordata.forecast[key - 1].value;
          }
          
          const timestamp = moment(a.datum).valueOf();
          
          barSeries.push([timestamp, value]);
          maxSeries.push([timestamp, soort.maxvalue]);
          minSeries.push([timestamp, soort.minvalue]);
          categories.push(timestamp);
        }
      });
      
      return { barSeries, maxSeries, minSeries, categories };
    }

    const chartData = prepareApexData(sensor || {});
    
    // ApexCharts configuration
    const options = {
      chart: {
        type: 'line',
        height: 400,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        animations: {
          enabled: false
        }
      },
      colors: ['#696cff', '#ff3e1d', '#03c3ec'],
      stroke: {
        curve: 'smooth',
        width: [0, 2, 2],
        dashArray: [0, 4, 4]
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          columnWidth: '60%',
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        type: 'datetime',
        categories: chartData.categories,
        labels: {
          format: type === "maand" ? "MMM yy" : type === "uur" || type === "uren" ? "HH:mm" : "dd MMM",
          datetimeUTC: false
        },
        title: {
          text: 'Datum'
        }
      },
      yaxis: {
        title: {
          text: soortsensor(soort.soort).naam
        },
        labels: {
          formatter: function (val) {
            return val.toFixed(2);
          }
        }
      },
      tooltip: {
        x: {
          format: type === "maand" ? "MMM yyyy" : type === "uur" || type === "uren" ? "dd MMM HH:mm" : "dd MMM yyyy"
        },
        y: {
          formatter: function (val, { seriesIndex }) {
            const sensorInfo = soortsensor(soort.soort);
            if (seriesIndex === 1) return `Max: ${val.toFixed(2)} ${sensorInfo.naam}`;
            if (seriesIndex === 2) return `Min: ${val.toFixed(2)} ${sensorInfo.naam}`;
            return `${val.toFixed(2)} ${sensorInfo.naam}`;
          }
        }
      },
      legend: {
        show: true,
        position: 'top'
      },
      grid: {
        borderColor: '#e7e7e7',
        strokeDashArray: 3
      }
    };

    const series = [
      {
        name: soortsensor(soort.soort).titel,
        type: 'column',
        data: chartData.barSeries
      },
      {
        name: 'Maximaal correct',
        type: 'line',
        data: chartData.maxSeries
      },
      {
        name: 'Minimaal correct',
        type: 'line',
        data: chartData.minSeries
      }
    ];

    return (
      <div style={{ width: '100%', height: '400px' }}>
        {chartData.barSeries.length > 0 ? (
          <Chart
            options={options}
            series={series}
            type="line"
            height={400}
          />
        ) : (
          <div style={{ 
            height: '400px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: '#666'
          }}>
            Loading Chart...
          </div>
        )}
      </div>
    );
  }
}
